import list from "@/pages/warehouse/list";
import listProducts from "@/pages/warehouse/listProducts";
import add from "@/pages/warehouse/add";
import edit from "@/pages/warehouse/edit";
import addWarehouseProduct from "@/pages/warehouse/addWarehouseProduct";
import exportWarehouseProduct from "@/pages/warehouse/exportWarehouseProduct";
import warehouseTransactions from "@/pages/warehouse/warehouseTransactions";
import warehouseInvoice from "@/pages/warehouse/warehouseInvoiceList";
import showWarehouseInvoice from "@/pages/warehouse/showWarehouseInvoice";
import warehouseProductChangeQuantity from "@/pages/warehouse/wPchangeQuantity";

const routes = [
  {
    path: "/Warehouse/Manage",
    component: list,
    meta: {requiredAuth: true},
  },
  {
    path: "/Warehouse/Add",
    component: add,
    meta: {requiredAuth: true},
  },
  {
    path: "/Warehouse/Edit/:warehouseId",
    component: edit,
    meta: {requiredAuth: true},
  },
  {
    path: "/WarehouseProduct/List/:warehouseId",
    component: listProducts,
    meta: {requiredAuth: true},
  },
  {
    path: "/WarehouseProductAddIn/:warehouseId",
    component: addWarehouseProduct,
    meta: {requiredAuth: true},
  },
  {
    path: "/WarehouseProductAddOut/:warehouseId",
    component: exportWarehouseProduct,
    meta: {requiredAuth: true},
  },
  {
    path: "/WarehouseTransaction/List/:warehouseId/:productId?",
    component: warehouseTransactions,
    meta: {requiredAuth: true},
  },
  {
    path: "/WarehouseInvoice/List/:warehouseId",
    component: warehouseInvoice,
    meta: {requiredAuth: true},
  },
  {
    path: "/WarehouseInvoice/show/:invoiceId",
    component: showWarehouseInvoice,
    meta: {requiredAuth: true},
  },
  {
    path: "/WarehouseProduct/ChangeQuantity/:id",
    component: warehouseProductChangeQuantity,
    meta: {requiredAuth: true},
  },
]

export default routes